// @ts-nocheck

import React, { useState, FunctionComponent } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { formatDate } from 'Constants/formatDate'
import { changeStartDateEvent } from 'Helpers/tagManager'
import { getCampaignToSchedule } from 'Redux/selectors/campaigns'
import { Toggle } from 'Containers/ui/Toggle'
import { DatePicker } from 'Shared/components/DatePicker'
import spotifyIcon from 'Shared/img/svg/spotify.svg'
import chevronIcon from 'Shared/img/svg/chevron-right.svg'

import { useCheckout } from '../../../../Hooks/payment'
import { TrackInfo } from '../TrackInfo'
import { CampaignGenres } from '../CampaignGenres'
import { CampaignLanguages } from '../CampaignLanguages'

import { AddedTrackProps } from './props'
import {
  AddedTrackContainer,
  MainContent,
  Headline,
  SpotifyIcon,
  Title,
  DetailsButton,
  DetailsButtonMobile,
  ChevronIcon,
  DetailsContainer,
  DetailsRow,
  RowLabel,
  DatePickerContainer,
} from './styles'

export const AddedTrack: FunctionComponent<AddedTrackProps> = ({
  shouldDetailsAppear,
  selectedDate,
  setSelectedDate,
}) => {
  const { t } = useTranslation()

  const [areDetailsOpened, setAreDetailsOpened] = useState(false)

  const campaignDetails = useSelector(getCampaignToSchedule)

  const toggleDetails = () => {
    setAreDetailsOpened(!areDetailsOpened)
  }

  const onClickChangeDate = (date: string) => {
    changeStartDateEvent(campaignDetails.status)
    setSelectedDate(date)
  }

  return (
    <AddedTrackContainer>
      <MainContent>
        <Headline>
          <SpotifyIcon src={spotifyIcon} alt="" />
          <Title>{t('scheduleCampaignPage.spotifyCampaign')}</Title>
        </Headline>
        <TrackInfo />
        {shouldDetailsAppear && (
          <DetailsButtonMobile onClick={toggleDetails}>
            {t('scheduleCampaignPage.campaignDetails')}
            <ChevronIcon
              src={chevronIcon}
              alt=""
              areDetailsOpened={areDetailsOpened}
            />
          </DetailsButtonMobile>
        )}
        {shouldDetailsAppear && (
          <DetailsContainer areDetailsOpened={areDetailsOpened}>
            <CampaignGenres
              genres={campaignDetails ? campaignDetails.genres : []}
            />
            <CampaignLanguages
              languages={campaignDetails ? campaignDetails.languages : []}
            />
            <DetailsRow divider>
              <RowLabel>{t('scheduleCampaignPage.campaignStartDate')}</RowLabel>
              {moment(selectedDate).format(formatDate.formatDateMonthFull)}
            </DetailsRow>
            <DetailsRow>
              <RowLabel>{t('scheduleCampaignPage.duration')}</RowLabel>
              {t('scheduleCampaignPage.14days')}
            </DetailsRow>

            <DatePickerContainer>
              <DatePicker
                defaultDate={selectedDate}
                onChangeDate={onClickChangeDate}
              />
            </DatePickerContainer>
          </DetailsContainer>
        )}
      </MainContent>
      {shouldDetailsAppear && (
        <DetailsButton onClick={toggleDetails}>
          {t('scheduleCampaignPage.campaignDetails')}
          <ChevronIcon
            src={chevronIcon}
            alt=""
            areDetailsOpened={areDetailsOpened}
          />
        </DetailsButton>
      )}
    </AddedTrackContainer>
  )
}
